import Config from '../Config';
import NucleusNetwork from '../utils/NucleusNetwork';
class CaregiverApi {
  private context: any;
  constructor(context) {
    this.context = context;
  }

  // //<----------------------------------Get User Data-------------------------------->
  // GetCarePatientData (data,callback) {
  // 	NucleusNetwork.request({
  // 		context : this.context,
  // 		type : "GET",
  // 		url: Config.domain + "GetCarePatientData.aspx",
  // 		data : data,
  // 		callback : callback,
  // 	});
  // }

  //<---------------------------------Update Caregiver Data----------------------------->
  UpdateCaregiverData(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/Update',
      data: data,
      callback: callback,
    });
  }

  //<-------------------------------Add New Assignment ----------------------->
  UpdateAssignment(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/UpdateAssignment',
      data: data,
      callback: callback,
    });
  }

  //<-----------------------------------Check Out----------------------------->
  CheckOut(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/CheckOut',
      data: data,
      callback: callback,
    });
  }

  //<------------------------------Delete Assignment------------------------->
  DeleteAssignment(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/DeleteAssignment',
      data: data,
      callback: callback,
    });
  }

  //<------------------------Get Caregiver Assignments ------------------------>
  GetCaregiverAssignments(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/ListAssignments',
      data: data,
      callback: callback,
    });
  }

  // //<-----------------------Update Call Log Notes --------------------------->
  // UpdateCallLogNotes (data,callback) {
  // 	NucleusNetwork.request({
  // 		context : this.context,
  // 		type : "POST",
  // 		url: Config.domain + "UpdateCareCallLogNotes.aspx",
  // 		data : data,
  // 		callback : callback,
  // 	});
  // }

  SendCaregiverSMS(data, callback) {
    NucleusNetwork.request({
      context: this.context,
      type: 'POST',
      url: Config.domain + 'CareGiver.asmx/SendSMS',
      data: data,
      callback: callback,
    });
  }
}

export default CaregiverApi;
